import { render, staticRenderFns } from "./novo_apo.vue?vue&type=template&id=0edbd0be&"
import script from "./novo_apo.vue?vue&type=script&lang=js&"
export * from "./novo_apo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edbd0be')) {
      api.createRecord('0edbd0be', component.options)
    } else {
      api.reload('0edbd0be', component.options)
    }
    module.hot.accept("./novo_apo.vue?vue&type=template&id=0edbd0be&", function () {
      api.rerender('0edbd0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/painel_apo/novo_apo.vue"
export default component.exports